<i class="{{cssClass}} fa fa-sign-out" [routerLink]="routerLink" aria-hidden="true" matTooltip="Salir"></i>